import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const StagingBar = ({ count = 0, onReview, onClear }) => {
  if (!count) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40">
      <div className="bg-card border-t border-border shadow-lg">
        <div className="max-w-screen-2xl mx-auto px-6 py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-sm text-foreground">
            <Icon name="ShoppingCart" size={16} className="text-primary" />
            <span className="font-medium">
              {count} Price Update{count === 1 ? '' : 's'} Staged
            </span>
          </div>
          <div className="flex items-center gap-2">
            {onClear && (
              <Button variant="outline" size="sm" onClick={onClear}>
                Clear
              </Button>
            )}
            <Button variant="default" size="sm" onClick={onReview} iconName="ClipboardList">
              Review Batch
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StagingBar;
